import React, { useState, } from 'react';
import { Button, TextField } from '@mui/material';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/API/LoginAPI';
import useAuth from '../hooks/useAuth';
import '../styles/login-page.css';
import SnackbarNotification from '../components/SnackbarNotification';



const LoginPage = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async ({username, password}) => {
    if (!username || !password) {
      return;
    }

    const response = await login(username, password);
    if (response.status === 200) {
      setAuth({ username, password, roles: response?.data.roles, token: response?.data.token});
      navigate("/admin/menu");
    }
  }

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Een gebruikersnaam is verplicht!"),
    password: Yup.string().required("Een wachtwoord is verplicht!"),
  });

  const initialValues = {username: "", password: ""}

  return (
    <>
      <div className='login-page__container'>
        <Formik
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={handleSubmit}
        > 
          <Form className='login-page__form'>
            <Field
              name="username"
              component={({field, form, ...props}) => (
                <TextField 
                  id="outlined-basic" 
                  name="username"
                  label="Gebruikersnaam" 
                  variant="outlined" 
                  margin="normal"
                  error={!!form.errors.username}
                  helperText={!!form.errors.username ? form.errors.username : ""}
                  {...field}
                />
              )}
            />
            <Field
              name="password"
              component={({field, form, ...props}) => (
                <TextField 
                  id="outlined-basic" 
                  name="password"
                  label="Wachtwoord" 
                  variant="outlined" 
                  type="password" 
                  margin="normal"
                  error={!!form.errors.password}
                  helperText={!!form.errors.password ? form.errors.password : ""}
                  {...field}
                />
              )}
            />
            <Button type='submit' variant='contained'>Login</Button>
          </Form>
        </Formik>
      </div>
      <SnackbarNotification/>
    </>
    
  );
}

export default LoginPage
